// Min/max for individual bars
const MinBarHeight = 3;
const MaxBarHeight = 8;
const VerticalBarPadding = 2;
// Min height for a group: need 10px for label (> MinBarHeight + VerticalBarPadding)
const MinGroupHeight = 10;

export interface PortfolioSummaryChartDimensions {
    /*
     * No. of groups that can fit on the chart
     */
    displayGroupCount: number;
    /*
     * Calculated bandwidth for an individual bar
     */
    bandWidth: number;
    /*
     * Actual group height
     */
    actualGroupHeight: number;
}
export function calculateDimensions(
    groupsCount: number,
    chartHeight: number
): PortfolioSummaryChartDimensions {
    const availableChartHeight = chartHeight - VerticalBarPadding; // adjust for Top padding. Remaining padding catered for in group height
    const maxGroups = Math.floor(availableChartHeight / MinGroupHeight);

    const displayGroupCount = Math.min(maxGroups, groupsCount);

    const actualGroupHeight = availableChartHeight / displayGroupCount;
    const actualBandWidth = (actualGroupHeight - VerticalBarPadding) / 2;
    const bandWidth = Math.max(
        MinBarHeight,
        Math.min(actualBandWidth, MaxBarHeight)
    );

    return { displayGroupCount, bandWidth, actualGroupHeight };
}
